import { useEffect } from 'react';
import PropTypes from 'prop-types';

import ModalPortal from './ModalPortal';
import { useModalContext } from '../providers';

/**
 *
 * @param {Object<{string: any}>} availableModals
 * @constructor
 */
export function ModalHandler({ availableModals = {} }) {
  const { modalName, closeModal, modalPayload } = useModalContext();

  // to disable the body scroll, (outside of react context)
  useEffect(() => {
    if (modalName) {
      document.body.style.overflow = 'hidden';
      document.body.style.paddingRight = '0';
    } else {
      document.body.style.overflow = null;
      document.body.style.paddingRight = null;
    }
  }, [modalName]);

  if (!modalName || !availableModals[modalName]) {
    return null;
  }
  const Component = availableModals[modalName];

  return (
    <ModalPortal>
      <Component closeModal={closeModal} payload={modalPayload} style={{ zIndex: 1001 }} />
    </ModalPortal>
  );
}

ModalHandler.propTypes = {
  availableModals: PropTypes.object
};

export default ModalHandler;
